import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navigation from '../navigation/navigationVisiteur';
import Notification from '../messagerie_user/notification';
import Motdepasse from './modificationMDP';
import GestionEquipe from './gestionEquipe';
import InformationCoach from './informationCoach';
import InformationEquipe from './informationEquipe';
import NavCoach from '../navigation/navCoach';


function ParametreCoach() {
  const Navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;



  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${apiUrl}/verification/cookie`,
          {},
          {
            withCredentials: true // Permet de transmettre les cookies avec la requête
          }
        );
        setUserData(response.data);
        setError(null);
        setIsLoading(false);
        if (response.data.user.type !== "coach") {
          Navigate('/connexion');
        }

      } catch (error) {
        if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        Navigate('/connexion')
        setIsLoading(false);

      }
    };

    fetchData(); 
  },[Navigate, apiUrl]);


        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }


        
  return (
  <>
  {userData ? (
    <>
      <NavCoach userData={userData} nom='Paramètres'/>
      <div className="main parametre_">
      <Notification userData = {userData}/>
          <div className="card">
            <InformationCoach userData={userData}/>
            <br/>
            <hr></hr>
            <br/>
            <Motdepasse userData = {userData}/>
            <br/>
            <hr></hr>
            <br/>
            <InformationEquipe userData={userData}/>
              <br/>
              <hr></hr>
              <br/>
            <GestionEquipe userData={userData}/>
          </div>
      </div>
      </>
      ) :(
        <>
        <Navigation/>        
      <div id="alert-message" className="alert" >
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
      </div></>
      )}
  </>
  );
}

export default ParametreCoach;
